module.exports = __webpack_public_path__ + "static/media/github_circle.aea24fea.png";